import React from 'react'
import Button from '../../../Button/Button'
import Style from './CommentById.module.scss'
const CommentById = ({rawInfo,handleOk}) => {
  return (
    <div className={Style.componentHolder}>
        <div className={Style.commentHolder}>
            <div className={Style.title}>نظر</div>
            <h2 className={Style.titleMessage}>کد سفارش:<span className={Style.orderId}>{rawInfo.orderId}</span></h2>
            {rawInfo.file?
            <div className={Style.imgHolder}>
              <img src={`https://cdn.barest.ir//support/${rawInfo.file}.jpg`} alt=""/>
            </div>:null
            }
            <p className={Style.comment}>{rawInfo.comment}</p>
        </div>
        <Button ClickHandler={handleOk} Value={"تایید"} ClassBtn={"okBtn"}/>
    </div>
  )
}

export default CommentById 